var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 11.5,
    fill: "#123164"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_712_472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.6113 15.5H27.8988C27.6957 14.5125 27.1584 13.6252 26.3774 12.9876C25.5964 12.3501 24.6195 12.0013 23.6113 12L21.8613 12C20.8531 12.0013 19.8762 12.3501 19.0952 12.9876C18.3142 13.6252 17.7769 14.5125 17.5738 15.5H14.8613C14.6293 15.5 14.4067 15.5922 14.2426 15.7563C14.0785 15.9204 13.9863 16.1429 13.9863 16.375C13.9863 16.6071 14.0785 16.8296 14.2426 16.9937C14.4067 17.1578 14.6293 17.25 14.8613 17.25H15.7363V28.625C15.7377 29.7849 16.1991 30.8969 17.0193 31.7171C17.8394 32.5372 18.9514 32.9986 20.1113 33H25.3613C26.5212 32.9986 27.6332 32.5372 28.4534 31.7171C29.2736 30.8969 29.7349 29.7849 29.7363 28.625V17.25H30.6113C30.8434 17.25 31.066 17.1578 31.23 16.9937C31.3941 16.8296 31.4863 16.6071 31.4863 16.375C31.4863 16.1429 31.3941 15.9204 31.23 15.7563C31.066 15.5922 30.8434 15.5 30.6113 15.5ZM21.8613 13.75H23.6113C24.1541 13.7507 24.6833 13.9192 25.1265 14.2325C25.5697 14.5458 25.9051 14.9886 26.0867 15.5H19.386C19.5676 14.9886 19.903 14.5458 20.3462 14.2325C20.7893 13.9192 21.3186 13.7507 21.8613 13.75ZM27.9863 28.625C27.9863 29.3212 27.7098 29.9889 27.2175 30.4812C26.7252 30.9734 26.0575 31.25 25.3613 31.25H20.1113C19.4151 31.25 18.7475 30.9734 18.2552 30.4812C17.7629 29.9889 17.4863 29.3212 17.4863 28.625V17.25H27.9863V28.625Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9863 27.75C21.2184 27.75 21.441 27.6578 21.605 27.4937C21.7691 27.3296 21.8613 27.1071 21.8613 26.875V21.625C21.8613 21.3929 21.7691 21.1704 21.605 21.0063C21.441 20.8422 21.2184 20.75 20.9863 20.75C20.7543 20.75 20.5317 20.8422 20.3676 21.0063C20.2035 21.1704 20.1113 21.3929 20.1113 21.625V26.875C20.1113 27.1071 20.2035 27.3296 20.3676 27.4937C20.5317 27.6578 20.7543 27.75 20.9863 27.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4863 27.75C24.7184 27.75 24.941 27.6578 25.105 27.4937C25.2691 27.3296 25.3613 27.1071 25.3613 26.875V21.625C25.3613 21.3929 25.2691 21.1704 25.105 21.0063C24.941 20.8422 24.7184 20.75 24.4863 20.75C24.2543 20.75 24.0317 20.8422 23.8676 21.0063C23.7035 21.1704 23.6113 21.3929 23.6113 21.625V26.875C23.6113 27.1071 23.7035 27.3296 23.8676 27.4937C24.0317 27.6578 24.2543 27.75 24.4863 27.75Z",
    fill: "white"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 44,
    rx: 11.5,
    stroke: "#D7D7D7"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_712_472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.4727,
    height: 21,
    fill: "white",
    transform: "translate(14 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashActive);
export default __webpack_public_path__ + "static/media/trashActive.ff98599a3980b0f2161320d30c1c9ff3.svg";
export { ForwardRef as ReactComponent };